import React, { FC, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { setDateEnd, setInfoOrderDetail } from 'redux/ordersDetails/slice';
import { Title } from 'components/Title';
import { ListSelect } from 'components/ListSelect';
import { InputDate } from 'components/InputDate';
import { AddressDadata } from 'components/AddressDadata';
import { InputText } from 'ui/InputText';
import { TextArea } from 'ui/TextArea';
import { InfoPercentType } from 'redux/auth/slice';
import { AppTooltip } from 'ui/AppTooltip';
import { ReactComponent as InfoSvg } from 'assets/img/iconInfo2big.svg';
import styles from './EditFieldsOrder.module.scss';
import classNames from 'classnames';
interface Type {
  id: number;
  name: string;
}
interface MixMaxPriceType {
  min: number;
  max: number;
}

interface EditFieldsOrderTypes {
  types: Type[];
  draft?: boolean;
  minMaxPrice?: MixMaxPriceType;
  balance: boolean;
  infoPercent: InfoPercentType;
  sumBalance: number;
}

export const EditFieldsOrder: FC<EditFieldsOrderTypes> = ({
  types,
  draft,
  minMaxPrice,
  balance,
  infoPercent,
  sumBalance = 0,
}) => {
  const [sortedTypes, setSortedTypes] = useState<Type[]>([]);

  const dispatch = useDispatch();
  const { infoOrderDetail } = useSelector((state: RootState) => state.ordersDetailsSlice);

  const [activeItem, setActiveItem] = useState<Type | null>(types ? types[0] : null);

  useEffect(() => {
    if (infoOrderDetail?.order_type) {
      setActiveItem(types?.find((e) => e.name === infoOrderDetail?.order_type) ?? null);
    }

    if (types) {
      const sorted = [...types].sort((a, b) => (a.name > b.name ? 1 : -1));
      setSortedTypes(sorted);
    }
  }, [types, infoOrderDetail]);

  useEffect(() => {
    dispatch(setInfoOrderDetail({ key: 'order_type_id', value: activeItem?.id }));
  }, [activeItem]);

  const sumWithPercent =
    +infoOrderDetail?.amount * (infoPercent?.commission_percent / 100) || 0;

  const iconRef = useRef<HTMLDivElement>(null);
  const fieldRef = useRef<HTMLDivElement>(null);

  const timeRightRef = useRef<HTMLDivElement>(null);

  const errorForAmountWithPercent =
    sumBalance <
    (sumWithPercent < infoPercent?.commission_min_amount
      ? +infoOrderDetail.amount + infoPercent.commission_min_amount
      : +infoOrderDetail.amount + +sumWithPercent.toFixed(2));

  return (
    <div className={styles.left}>
      <Title title='Данные заказа' />
      {sortedTypes && (
        <ListSelect
          style={{ height: 'auto' }}
          placeholder='Тип услуги *'
          list={sortedTypes}
          search
          activeItem={activeItem?.name}
          setActiveItem={setActiveItem}
        />
      )}
      <TextArea
        value={infoOrderDetail.description || ''}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
          dispatch(setInfoOrderDetail({ key: 'description', value: e.target.value }))
        }
        placeholder='Описание'
        orderFocus={true}
      />
      <div className={styles.inputBlock}>
        <div ref={timeRightRef} className={styles.inputBlock_item}>
          <InputDate
            draft={draft}
            placeholder='Дата окончания * '
            date={infoOrderDetail.date_end}
            setDate={setDateEnd}
          />
        </div>
      </div>
      <div style={{ justifyContent: 'flex-start' }} className={styles.inputBlock}>
        <div>
          <InputText
            error={
              (minMaxPrice &&
                (minMaxPrice.min > +infoOrderDetail.amount ||
                  minMaxPrice.max < +infoOrderDetail.amount) &&
                !!infoOrderDetail.amount) ||
              !balance
            }
            price='₽'
            value={String(infoOrderDetail.amount)}
            style={{ border: 'none' }}
            type='text'
            placeholder='Стоимость *'
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const str = e.target.value.replace(/[a-zA-Zа-яА-Я]/g, '').replace(',', '.');
              dispatch(
                setInfoOrderDetail({
                  key: 'amount',
                  value: str,
                }),
              );
            }}
          />
          <p
            style={
              (minMaxPrice &&
                (minMaxPrice.min > +infoOrderDetail.amount ||
                  minMaxPrice.max < +infoOrderDetail.amount) &&
                !!infoOrderDetail.amount) ||
              !balance
                ? {
                    marginTop: '9px',
                    color: '#e10d0d',
                    fontWeight: 500,
                    fontSize: '16px',
                    width: '345px',
                  }
                : { marginTop: '9px' }
            }>
            {!balance ? null : 'Допустимая сумма заказа от 1 000 до 50 000 ₽'}
          </p>
        </div>
        <div>
          <div
            style={{
              position: 'relative',
            }}
            ref={fieldRef}>
            <div className={styles.blockAmount}>
              <p
                className={classNames(
                  styles.amount,
                  errorForAmountWithPercent && styles.amount_error,
                )}>
                {infoOrderDetail.amount
                  ? sumWithPercent < infoPercent?.commission_min_amount
                    ? +infoOrderDetail.amount + infoPercent.commission_min_amount
                    : +infoOrderDetail.amount + +sumWithPercent.toFixed(2)
                  : 0}{' '}
                ₽
              </p>

              <div
                ref={iconRef}
                style={{
                  height: '24px',
                  position: 'relative',
                  marginTop: '11.5px',
                }}>
                <AppTooltip
                  label={`Комиссия площадки ${infoPercent.commission_percent} %, но не менее ${infoPercent.commission_min_amount} ₽`}
                  position='bottom'
                  offset={8}
                  arrowPosition='center'>
                  <InfoSvg />
                </AppTooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.location}>
        <Title title='Локация' />
        <div className={styles.location_type}>
          {['Удаленно', 'По адресу'].map((item, i) => (
            <button
              className={`${styles.button} ${
                infoOrderDetail.is_remote === item ? styles.active : ''
              }`}
              onClick={() => {
                dispatch(setInfoOrderDetail({ key: 'is_remote', value: item }));
                dispatch(setInfoOrderDetail({ key: 'apartment', value: '' }));
                dispatch(setInfoOrderDetail({ key: 'city', value: '' }));
                dispatch(setInfoOrderDetail({ key: 'street', value: '' }));
                dispatch(setInfoOrderDetail({ key: 'home', value: '' }));
              }}
              key={i}>
              {item}
            </button>
          ))}
        </div>
        {infoOrderDetail.is_remote !== 'Удаленно' && <AddressDadata />}
      </div>
    </div>
  );
};
